module.exports = __webpack_public_path__ + "img/img_my_identify_3.14d8df92.jpg";